import { render, staticRenderFns } from "./AuthenticationComponent.vue?vue&type=template&id=4764ead9&scoped=true&"
import script from "./AuthenticationComponent.vue?vue&type=script&lang=js&"
export * from "./AuthenticationComponent.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationComponent.vue?vue&type=style&index=0&id=4764ead9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4764ead9",
  null
  
)

export default component.exports